import mergeWith from "ramda/es/mergeWith";
import isPlainObject from "ramda-extension/es/isPlainObject";
const mergeDeepFormData = mergeWith((leftFormData, rightFormData)=>{
    if (isPlainObject(leftFormData) && isPlainObject(rightFormData) && !leftFormData?._isAMomentObject && !rightFormData?._isAMomentObject && !(leftFormData instanceof Date) && !(rightFormData instanceof Date)) {
        return mergeDeepFormData(leftFormData, rightFormData);
    } else {
        return rightFormData;
    }
});
export default mergeDeepFormData;
